module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc1-fa110c4f2980921f15b7ce58fe5da220.jpg";